// extracted by mini-css-extract-plugin
export var active = "_cb-7";
export var container = "_cb-0";
export var evenWidth = "_cb-4";
export var large = "_cb-5";
export var outlet = "_cb-8";
export var slide = "_cb-2";
export var small = "_cb-6";
export var tab = "_cb-3";
export var tabs = "_cb-1";